import { render, staticRenderFns } from "./jurisdiction.vue?vue&type=template&id=3c166130&scoped=true&"
import script from "./jurisdiction.vue?vue&type=script&lang=js&"
export * from "./jurisdiction.vue?vue&type=script&lang=js&"
import style0 from "./jurisdiction.vue?vue&type=style&index=0&id=3c166130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c166130",
  null
  
)

export default component.exports